import { NavBarLoggedIn } from '@/scenes/Header/NavBarLoggedIn';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { selectIsSignupIncomplete } from '@/store/user/selectors/selectIsSignupIncomplete';
import { useSelector } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';
import HeaderMain from './HeaderMain';
import NavBarLoggedOut from './NavBarLoggedOut';

export function HeaderContainer() {
  const location = useLocation();
  const [token] = useTokenState();
  const isLoggedIn = Boolean(token);
  const isSignupIncomplete = useSelector(selectIsSignupIncomplete);

  return (
    <div data-testid="header">
      {isLoggedIn && !isSignupIncomplete ? (
        <NavBarLoggedIn pathname={location.pathname} />
      ) : (
        <Routes primary={false}>
          <Route path="/" element={<HeaderMain />} />
          <Route path="*" element={<NavBarLoggedOut />} />
        </Routes>
      )}
    </div>
  );
}
